import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {PageServicesModule} from './services/page-services.module';
import {SecurityModule} from '../../components/security/security.module';

/**
 * Created by Rodrigo Quesada on 27/11/16.
 */
@NgModule({
    exports: [
        SecurityModule,
        CommonModule,
        RouterModule,
        PageServicesModule
    ]
})
export class PageCommonModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/page-common.module.ts